import classes from './SecondaryHeader.module.scss'
import { useNavigate } from 'react-router-dom'

const SecondaryHeader = ({ title }) => {
  const navigate = useNavigate()
  const backClick = () => {
    navigate(-1)
  }
  return (
    <>
      <header className={`${classes['secondary-header']} peer `}>
        <button
          type='button'
          onClick={backClick}
          className={classes['back-button']}
          title='بازگشت'
        >
          <i className='rayteb-back'></i>
          <span className='sr-only'>بازگشت</span>
        </button>
        <label className={classes['header-title']}>{title}</label>
      </header>
    </>
  )
}

export default SecondaryHeader
